import { createFileRoute } from "@tanstack/react-router";
import { RefundPolicy } from "@/lib/lazyPages";
import { SEO } from "@/config/seoConfig";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/refund-policy")({
  head: () => seoHead(SEO.refundPolicy),
  component: RefundPolicy,
});
